import React from 'react'

import { Avatar, ListItem, ListItemAvatar, ListItemText, makeStyles } from '@material-ui/core'

const useListStyles = makeStyles(theme => ({
  root: ({ isSelf }) => {
    const colors = theme.palette.info
    let customStyles = null

    if (isSelf) {
      customStyles = {
        backgroundColor: `${colors.light} !important`,
        opacity: 0.8
      }
    }

    return customStyles
  }
  // selected: ({ isSelf }) => {
  //   const colors = theme.palette[variant]
  //   return {
  //     color: colors.contrastText,
  //     backgroundColor: `${colors.light} !important`,
  //     opacity: 0.8
  //   }
  // }
}))

const UserFeedbackCard = ({ user = {}, onClick, selected }) => {
  const {
    full_name: fullName,
    profile_url: imgUrl,
    org,
    position,
    is_self: isSelf
    // is_chife: isChief,
    // is_subordinate: isSub
  } = user

  const orgName = org.org_name
  const positionName = position.position_name

  // let variant = 'info'
  // if (isChief) {
  //   variant = 'success'
  // } else if (isSub) {
  //   variant = 'warning'
  // }
  const listClasses = useListStyles({ isSelf })

  return (
    <ListItem
      classes={listClasses}
      button
      onClick={onClick}
      selected={selected}
      disabled={!!isSelf}>
      <ListItemAvatar>
        <Avatar alt={fullName} src={imgUrl} />
      </ListItemAvatar>
      <ListItemText
        primary={fullName}
        secondary={
          <>
            {orgName}
            <br />
            {positionName}
          </>
        }
      />
    </ListItem>
  )
}

export default UserFeedbackCard
